import type { ReactNode } from 'react';
import { SiteFadeInMount, SiteGridFadeIn } from '../components/SiteFadeIn';

interface WrapContentListBodyOptions {
  hasPanel: boolean;
  stack?: boolean;
}

/** SSOT fade-in for static ContentListPage body (non-list routes). */
export function wrapContentListBody(
  content: ReactNode,
  { hasPanel, stack = false }: WrapContentListBodyOptions,
): ReactNode {
  if (content == null || content === false) {
    return null;
  }

  if (hasPanel) {
    return <SiteFadeInMount stack={stack}>{content}</SiteFadeInMount>;
  }

  return <SiteGridFadeIn stack={stack}>{content}</SiteGridFadeIn>;
}

/** SSOT fade-in for ContentListPage footer blocks. */
export function wrapContentListFooter(content: ReactNode): ReactNode {
  if (content == null || content === false) {
    return null;
  }

  return <SiteFadeInMount>{content}</SiteFadeInMount>;
}
